import FightImg from "../../assets/game.jpg";
import "./index.less";

export default function Fight() {
  return (
    <div className="fight-container">
      <div className="game-img">
        <img src={FightImg} className="fight-img" width="100%" alt="" />
        <div className="text">COMING SOON</div>
      </div>
    </div>
  );
}
